export default function adaptProfileImage ( image ) {

    if (!image) {
        return '';
    }

    if (image.includes('[]')) {
        return '';
    }
    if (image.includes('{')) {
        let i;
        try {
            i = JSON.parse(image);
        } catch (e) {
            console.log('json error on image', image);
            return '';
        }

        for (let prop in i) {
            if (i.hasOwnProperty(prop)) {
                return i[prop];
            }
        }
        return '';
    } else {
        return image;
    }
};
